module.exports = __webpack_public_path__ + "img/ca.0a303f21.png";